import { createReducer } from '@ngrx/store';
import { IStudy, IStudyResponse } from '@shared/study.interface';

export const STUDY_FEATURE_KEY = 'study';

export interface StudyDetailState {
  study: IStudy | null;
  loading: boolean;
  error: string;
}

export interface StudyState {
  studies: IStudyResponse | null;
  loading: boolean;
  error: string;
  studyDetails: { [key: string]: StudyDetailState };
}

export const initialState: StudyState = {
  studies: null,
  loading: false,
  error: '',
  studyDetails: {},
};

export const studyReducer = createReducer(initialState);
